import { HowItWorkCarousel } from '@payfit/growth-platform-brand-system-v2/layouts/HowItWorkCarousel';
import { container } from '@payfit/growth-platform-brand-system-v2/src/styles/themes';
import morphism from 'morphism';
import React from 'react';
import { schemaHowItWork } from '../../morphismSchema/templates/schemaHowItWork';

export const HowItWorkComponent = ({ block, locale, sectionId }: any) => {
  const blockProps = {
    ...morphism(schemaHowItWork, {
      ...block,
      section: sectionId,
      locale,
    }),
  };

  return <HowItWorkCarousel {...blockProps} classNameContainer={container} />;
};

export default HowItWorkComponent;
